import React from "react";

export default function SaberOverlay({ phase }) {
  if (!phase) return null;
  return (
    <>
      <img
        src="/lightsaberhand.png"
        alt=""
        className={`saber-hand ${phase === "rise" ? "saber-raise" : phase === "slash" ? "saber-strike" : phase === "lower" ? "saber-withdraw" : "saber-struck"}`}
        draggable={false}
      />
      {(phase === "slash" || phase === "cut") && (
        <div className="saber-slash-trail" />
      )}
    </>
  );
}
